export default __webpack_public_path__ + "static/media/GR00010-ink_drip_2.846c7cc5.svg";